import { NavigationGuardNext } from 'vue-router'
import AuthService from '@/plugins/api-plugin/services/auth.service'

export default async function authMiddleware({
    next,
    nextMiddleware,
}: {
    next: NavigationGuardNext
    nextMiddleware: NavigationGuardNext
}) {
    if (AuthService.isAuth()) {
        return nextMiddleware()
    }

    location.href = `${process.env.VUE_APP_CO_BASE_URL}/Account/Login`

    return next({
        path: '/redirecting',
    })
}
